/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { Box, Typography } from "@material-ui/core";
import { OpenInNew as OpenInNewIcon } from "@material-ui/icons";
import Skeleton from "@material-ui/lab/Skeleton";
import {
  formatDate,
  formatNumber,
  openUrlInNewTab,
} from "../../../utils/helper";
import Button from "../../../components/common/Button";
import { ReactComponent as Level } from "../images/level.svg";
import { ReactComponent as Department } from "../images/department.svg";
import { ReactComponent as Employment } from "../images/employment.svg";
import { ReactComponent as Salary } from "../images/salary.svg";
import { ReactComponent as Experience } from "../images/experience.svg";
import { ReactComponent as Save } from "../../../assets/svg/save.svg";
import { ReactComponent as SaveActive } from "../../../assets/svg/save-active.svg";
import CompanyIcon from "../../../assets/images/company-icon.png";
import CompanyLocationIcon from "../../../assets/images/company-location-icon.png";
import ProfileViewModal from "../../../components/Candidates/ProfileViewModal";
import { useDispatch, useSelector } from "react-redux";
import useSessionUser from "../../../hooks/useSessionUser";
import {
  saveJobRequest,
  saveJobReset,
} from "../../../reducers/candidate/candidate.reducer";
import { rootReducersState } from "../../../reducers";
import { ReducerFlag } from "../../../types/reducer.types";
import { jobDetailUpdate } from "../../../reducers/job/jobs.reducer";
import FlashMessage from "../../../components/common/FlashMessage";
import { REMOTE_CHOICE } from "../../../utils/appConstants";
import LinkSVG from "../../../assets/svg/LinkSVG";
import JobShareModal from "../../../components/ProfileView/components/JobShareModal";
import copyToClipboard from "copy-to-clipboard";
import appRoutes from "../../../routes/app.routes";
import Avatar from "../../../components/common/AvtarImage";
import ConfirmDialog from "../../../components/common/ConfirmDialog";
import { MIN_PROFILE_COMPLETION_TO_APPLY } from "../../../utils/appConstants";
import candidateServices from "../../../services/candidate.services";
interface IJobDetailHeader {
  company_image: string;
  job_department_title: string;
  min_experience: string;
  max_experience: string;
  job_level_title: string;
  job_type_title: string;
  city: any;
  max_salary: number;
  min_salary: number;
  posted_on: string;
  salary_term: string;
  title: string;
  currency: string;
  loading?: boolean;
  applied?: number;
  saved?: number;
  token: string;
  slug: string;
  ats_link?: string;
}

const SKELETON_WIDTH = 350;

const JobDetailHeader: React.FC<IJobDetailHeader> = ({
  loading,
  token,
  company_image,
  city,
  posted_on,
  title,
  slug,
  applied,
  saved,
  ...rest
}) => {
  const atsLink = rest?.ats_link || "";
  const [openProfileViewModal, setOpenProfileViewModal] = useState(false);
  const [atsApplying, setAtsApplying] = useState(false);
  const [showProfileCompletionPrompt, setShowProfileCompletionPrompt] =
    useState(false);
  const [profileProgress, setProfileProgress] = useState(0);
  const [publicProfileLink, setPublicProfileLink] = useState("");
  const [profileShareModal, setProfileShareModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { IS_COMPANY, currentUser } = useSessionUser();
  const companyName = _.get(rest, "companyProfile.company_name", "") || "";
  const { detail: jobDetails } = useSelector(
    ({ job }: rootReducersState) => job?.jobs
  );
  const {
    jobSavedFlagMessage,
    jobSavedFlag,
    jobSavedFlagData,
    jobSavedRequestId,
  } = useSelector(
    ({ candidate }: rootReducersState) => candidate?.candidates
  );
  const currentJobId = _.get(rest, "id", 0);
  const isApplied = Number(applied) === 1;

  const INFO_ITEMS = useMemo(
    () => [
      // {
      //   id: 1,
      //   name: "Experience",
      //   icon: Experience,
      //   value:
      //     _.get(rest, "min_experience", "0") === "0" ||
      //     _.get(rest, "min_experience", "0") === "" ||
      //     _.get(rest, "max_experience", "0") === "0" ||
      //     _.get(rest, "max_experience", "0") === ""
      //       ? "HIDE"
      //       : `${_.get(rest, "min_experience", "")}-${_.get(
      //           rest,
      //           "max_experience",
      //           ""
      //         )} Years`,
      // },
      {
        id: 1,
        name: "Level",
        icon: Level,
        value: <p className="ml-nrml">{_.get(rest, "job_level_title", "-")}</p>,
      },
      {
        id: 2,
        name: "Department",
        icon: Department,
        value:
          (_.get(rest, "job_department_title", "HIDE") || "HIDE") === "HIDE" ? (
            "HIDE"
          ) : (
            <p className="ml-nrml">{_.get(rest, "job_department_title")}</p>
          ),
      },
      {
        id: 3,
        name: "Employment",
        icon: Employment,
        value: <p className="ml-nrml">{_.get(rest, "job_type_title", "-")}</p>,
      },
      {
        id: 4,
        name: "Support Visa",
        icon: Experience,
        value:
          _.get(rest, "support_visa", null) === null ? (
            "HIDE"
          ) : (
            <p className="ml-nrml">
              {_.get(rest, "support_visa") === 1
                ? "Visa support"
                : "No visa support"}
            </p>
          ),
      },
      {
        id: 5,
        name: `Salary ${
          _.get(rest, "min_salary") || _.get(rest, "max_salary")
            ? rest.salary_term === "per_hour"
              ? " - Hourly"
              : rest.salary_term === "annual"
              ? " - Annual"
              : ""
            : ""
        }`,
        icon: Salary,
        value:
          !_.get(rest, "min_salary") || !_.get(rest, "max_salary") ? (
            <p className="ml-nrml">N/A</p>
          ) : (
            <p className="ml-nrml">
              {`${_.get(rest, "currency", "")}`} {" "}
              {`${formatNumber(
                Number(_.get(rest, "min_salary", 0))
              )} - ${formatNumber(Number(_.get(rest, "max_salary", 0)))}`}
            </p>
          ),
      },
    ],
    [rest]
  );

  // Update detail save state only when the saved job is this page's job
  useEffect(() => {
    if (jobSavedFlag === ReducerFlag.SUCCESS) {
      if (Number(jobSavedRequestId) === Number(currentJobId)) {
        dispatch(
          jobDetailUpdate({
            ...jobDetails,
            saved: _.get(jobSavedFlagData, "saved", null) || null,
          })
        );
      }
      dispatch(saveJobReset());
    } else if (jobSavedFlag === ReducerFlag.FAILED) {
      if (Number(jobSavedRequestId) === Number(currentJobId)) {
        FlashMessage(jobSavedFlagMessage, "error");
      }
      dispatch(saveJobReset());
    }
  }, [jobSavedFlag]);

  const _handleSaveJob = () => {
    const jobId = _.get(rest, "id", 0);
    dispatch(saveJobRequest(jobId));
  };
  const _handleUnsaveJob = () => {
    const jobId = _.get(rest, "id", 0);
    dispatch(saveJobRequest(jobId)); // Or your unsave action if different
  };
  const shareProfile = () => {
    const link = appRoutes.jobDetail.generatePath(slug);
    setProfileShareModal(true);
    setPublicProfileLink(link);
  };
  const _copyProfileLink = () => {
    const link = appRoutes.jobDetail.generatePath(slug);
    copyToClipboard(link);
    FlashMessage("Copied profile link");
  };

  const _handleApplyNow = async () => {
    if (!token) {
      navigate(appRoutes.userLogin.path);
      return;
    }

    const progress = Number(_.get(currentUser, "profile.profile_progress", 0));

    if (progress < MIN_PROFILE_COMPLETION_TO_APPLY) {
      setProfileProgress(progress);
      setShowProfileCompletionPrompt(true);
      return;
    }

    if (atsLink) {
      if (atsApplying) return;

      setAtsApplying(true);
      openUrlInNewTab(atsLink);

      try {
        const response = await candidateServices.candidateApplyJob({
          id: currentJobId,
          formData: {},
        });

        const alreadyApplied =
          response.message === "You have already applied for the job";

        if (response.flag === true || alreadyApplied) {
          const currentApplicants = Number(
            _.get(jobDetails, "totalApplicants", 0)
          );
          dispatch(
            jobDetailUpdate({
              ...jobDetails,
              applied: 1,
              totalApplicants: alreadyApplied
                ? currentApplicants
                : currentApplicants + 1,
            })
          );
        } else {
          FlashMessage(
            response.message || "Unable to save this application",
            "error"
          );
        }
      } catch (error: any) {
        FlashMessage(
          error?.message || "Unable to save this application",
          "error"
        );
      } finally {
        setAtsApplying(false);
      }
      return;
    }

    setOpenProfileViewModal(true);
  };

  const _handleCompleteProfile = () => {
    setShowProfileCompletionPrompt(false);
    navigate(appRoutes.candidateProfileView.path);
  };

  return (
    <Box className="job-detail-header">
      <Box className="job-header-inner">
        {loading ? (
          <Skeleton width={SKELETON_WIDTH} variant="text" />
        ) : (
          <>
            <Typography className="title" variant="h3">
              {title}
            </Typography>
          </>
        )}
        {!IS_COMPANY && (
          <Box className="details-buttons-Wrapper">
            {loading ? (
              <Skeleton variant="rect" width={130} height={40} />
            ) : (
              <>
                <Button
                  onClick={() => {
                    if (!isApplied) _handleApplyNow();
                  }}
                  color={"primary"}
                  className="apply-now"
                  disabled={isApplied}
                  loading={atsApplying}
                  endIcon={atsLink !== "" ? <OpenInNewIcon /> : undefined}
                >
                  {isApplied ? "Applied" : "Apply Now"}
                </Button>
                {token && (
                  <Box className="mb-5 d-flex gap-1 mt-2">
                    <Box
                      className="like-btn cursor-pointer icon"
                      component="span"
                    >
                      {saved === 1 ? (
                        <Box
                          className="like-active rounded-container"
                          component="span"
                        >
                          <SaveActive
                            width={20}
                            height={20}
                            onClick={_handleUnsaveJob}
                          />
                        </Box>
                      ) : (
                        <Box
                          className="like-unactive rounded-container"
                          component="span"
                        >
                          <Save
                            width={20}
                            height={20}
                            onClick={_handleSaveJob}
                          />
                        </Box>
                      )}
                    </Box>
                    {/* You can show a count or label here if needed */}
                  </Box>
                )}
              </>
            )}
            {/* {loading ? (
                <Skeleton variant="rect" width={160} height={40} />
              ) : (
                token && (
                  <div className="mb-5 d-flex gap-1 mt-2">
                    <span className="like-btn cursor-pointer">
                      {saved === 1 ? (
                        <span className="like-active">
                          <HeartActive
                            width={20}
                            height={20}
                            onClick={_handleUnsaveJob}
                          />
                        </span>
                      ) : (
                        <Heart
                          width={20}
                          height={20}
                          onClick={_handleSaveJob}
                        />
                      )}
                    </span>
            
                  </div>
                )
              )} */}
            {loading ? (
              <Skeleton variant="rect" width={160} height={40} />
            ) : (
              token && (
                <Box
                  className="share-profile cursor-pointer icon"
                  component="span"
                  onClick={() => shareProfile()}
                >
                  <LinkSVG />
                </Box>
              )
            )}
          </Box>
        )}
      </Box>

      <Box className="upper">
        <Box className="logo">
          {loading ? (
            <Skeleton variant="circle" />
          ) : (
            <Avatar src={company_image} type="job" />
          )}
        </Box>
        <Box className="content">
          <Box>
            <Box className="d-flex company-details">
              {loading ? (
                <Skeleton width={SKELETON_WIDTH / 2} />
              ) : (
                <>
                  <Box className="job-description">
                    <Box className="company-info">
                      <img src={CompanyIcon} alt="Company Icon" />
                      {companyName}
                    </Box>
                    <Box className="company-info">
                      <img
                        src={CompanyLocationIcon}
                        alt="Company Location Icon"
                      />
                      {city?.location}
                    </Box>
                    <Typography
                      className="remote"
                      component="span"
                      variant="body2"
                    >
                      (
                      {REMOTE_CHOICE.find(
                        (row) => row.value === _.get(rest, "is_remote", "1")
                      )?.label || "On-Site"}
                      )
                    </Typography>
                  </Box>
                </>
              )}
            </Box>
            <Box className="posted">
              {loading ? (
                <Skeleton width={SKELETON_WIDTH / 3} />
              ) : (
                <Typography component="span" variant="body2">
                  <Typography component="span" variant="body2">
                    Posted on:
                  </Typography>
                  <span className="date-text">{formatDate(posted_on)}</span>
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
      <Box component="span" className="separator separator-pink" />
      <Box className="info">
        {INFO_ITEMS.filter((row) => row.value !== "HIDE").map(
          ({ id, name, icon: Icon, value }) => {
            return (
              <Box key={id} className="item">
                <Box>
                  {loading ? <Skeleton variant="circle" /> : <Icon />}
                  {loading ? <Skeleton variant="text" /> : name}
                </Box>
                {loading ? <Skeleton variant="text" width={80} /> : value}
              </Box>
            );
          }
        )}
      </Box>
      <ProfileViewModal
        className="profile-view-modal"
        visible={openProfileViewModal}
        size="x-large"
        jobData={rest}
        onClose={() => setOpenProfileViewModal(false)}
      />
      <JobShareModal
        publicProfileLink={publicProfileLink}
        open={profileShareModal}
        onClose={() => setProfileShareModal(false)}
        copyProfileLink={_copyProfileLink}
      />
      <ConfirmDialog
        visible={showProfileCompletionPrompt}
        title="Complete your profile"
        bodyText={
          <>
            Your profile is {profileProgress}% complete. You need at least{" "}
            {MIN_PROFILE_COMPLETION_TO_APPLY}% to apply for jobs. Please complete
            your profile before submitting an application.
          </>
        }
        confirmText="Complete Profile"
        cancelText="Cancel"
        onConfirm={_handleCompleteProfile}
        onCancel={() => setShowProfileCompletionPrompt(false)}
      />
    </Box>
  );
};

export default JobDetailHeader;
